import { createStyles, withStyles, WithStyles } from '@domonda/ui/styles';

const styles = createStyles(({ palette }) => ({
  navigation: {
    borderRight: `1px solid ${palette.border}`,
    backgroundColor: palette.lightest('background'),
  },
  invoice: {
    '& > *': {
      width: '100%',
      height: '100%',
    },
  },
  grid: {
    backgroundColor: '#ffffff'
  }
}));

export type Decorate = WithStyles<typeof styles>;

export const decorate = withStyles(styles);